module.exports = __webpack_public_path__ + "static/badge-warranty-150x150-a996ea8f2998a7d7b8b17ee068cad394.jpg";